import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import useStores, { observer } from "stores";

const BreadcrumbComp = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // const [breadcrumbItems, setBreadcrumbItems] = useState(defaultItem);
  const { commonStore } = useStores();
  const { menuList, menuNmPath, setMenuNmPath, defaultMenu } = commonStore;

  useEffect(() => {
    if (menuList?.length > 0) {
      setMenuNmPath(getMenuNmArry());
    }
  }, [menuList]);
  
  useEffect(() => {
    setMenuNmPath(getMenuNmArry());
  }, [pathname]);

  const defaultItem = [{
    //href: '',
    title: <HomeOutlined onClick={()=>navigate('/' + defaultMenu)}/>,
  }];

  const getMenuNmArry = () => {
    const keyPath = pathname?.split('/').slice(1);
    let nameArry = [...defaultItem];
    if (menuList?.length > 0 && keyPath?.length > 0) {
      const menuIndex = menuList.findIndex(item=>item.key === keyPath[0]);
      menuIndex >= 0 && nameArry.push({title: menuList[menuIndex]?.title || ''});
      if (keyPath?.length > 1) {
        const menuCdIndex = menuList[menuIndex]?.children?.findIndex(item=>item.key === keyPath[1]);
        menuCdIndex >= 0 && 
          nameArry.push({title: menuList[menuIndex]?.children[menuCdIndex].title || ''});
      }
    }
    return nameArry;
  }

  return (
    <Breadcrumb 
      items={menuNmPath}
    />
  );
}

export default observer(BreadcrumbComp);